import React from 'react';
import { Button, Stack, Text, Title } from '@mantine/core';
import { IconAlertTriangle } from '@tabler/icons-react';
import { useTranslation } from 'react-i18next';
import { DefaultErrorFallbackProps } from './DefaultErrorFallback.types';
import styles from '../ErrorBoundary/ErrorBoundary.module.css';

/**
 * Default Error UI Component using i18n and Mantine
 */
export const DefaultErrorFallback: React.FC<DefaultErrorFallbackProps> = ({
  error,
  onReset,
}) => {
  const { t } = useTranslation();

  if (error) {
    console.error('ErrorBoundary caught:', error);
  }

  return (
    <Stack
      align="center"
      justify="center"
      gap="md"
      className={styles.errorContainer}
    >
      <IconAlertTriangle size={48} stroke={1.5} />
      <Title order={3}>{t('ui.errorBoundary.title')}</Title>
      <Text size="sm" c="dimmed" ta="center">
        {t('ui.errorBoundary.message')}
      </Text>
      <Button variant="light" color="red" onClick={onReset}>
        {t('ui.errorBoundary.tryAgain')}
      </Button>
    </Stack>
  );
};
